import { render, staticRenderFns } from "./cmp-md-attr-keywords-filter.vue?vue&type=template&id=212a6b5c&"
import script from "./cmp-md-attr-keywords-filter.vue?vue&type=script&lang=ts&"
export * from "./cmp-md-attr-keywords-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cmp-md-attr-keywords-filter.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports